import React from 'react';
import type {MoneyV2} from '@shopify/hydrogen/storefront-api-types';
import {isDiscounted} from '~/lib/utils';
import clsx from 'clsx';
import {useMatches} from '@remix-run/react';

//domains
import {CurrencySettingsGlobal, formatCurrency} from 'domains/currency';

export default function ProductPrices({
  price,
  compareAtPrice,
  type = 'shopify',
}: {
  price: MoneyV2;
  compareAtPrice: MoneyV2;
  type: 'shopify' | 'bfs';
}) {
  const [root] = useMatches();
  const req_url_host = root.data.req_url_host as string;
  const currency = root.data.currency as CurrencySettingsGlobal;
  const selectedCurrency = currency.selectedCurrency;

  if (type === 'shopify') {
    // console.log(price);
    // console.log(selectedCurrency);
    // console.log(currency.baseCurrency);
    // console.log(currency.exchangeRates);
    const priceFormatted = formatCurrency({price, currency});
    const compareAtPriceFormatted =
      isDiscounted(price as MoneyV2, compareAtPrice as MoneyV2) &&
      formatCurrency({price: compareAtPrice, currency});
    return (
      <div
        className={clsx(
          // Price is primary purchase info — 14px minimum on mobile (was
          // text-xs/12px, below the typography guide's floor for key text).
          'flex justify-center font-bold text-sm md:text-md',
          req_url_host === 'tw.helmetking.com' && 'flex-col md:flex-row',
        )}
      >
        {/* Code and amount both come out of formatCurrency, so the label can
            never name a currency the number was not converted to. The
            tw.helmetking.com special case that used to sit here printed the
            raw amount because the old converter ran parseInt and ate the
            cents; parseFloat means the ordinary path is now correct there
            too. */}
        {compareAtPriceFormatted ? (
          <span className="mr-1 font-normal text-darkGray line-through decoration-red md:mr-3">
            {compareAtPriceFormatted.currencyCode}
            {compareAtPriceFormatted.amount.toFixed(2)}
          </span>
        ) : null}
        <span className={clsx('font-normal')}>
          {priceFormatted?.currencyCode}
          {priceFormatted?.amount.toFixed(2)}
        </span>
      </div>
    );
  }

  return <></>;
}
